import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderSlot as _renderSlot, normalizeStyle as _normalizeStyle, withKeys as _withKeys, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, Teleport as _Teleport, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-608b8ee0"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "modal-bg fixed inset-0 bg-gray-500 bg-opacity-75" }, null, -1))
const _hoisted_2 = { class: "fixed z-20 inset-0 overflow-y-auto" }
const _hoisted_3 = { class: "flex items-end sm:items-center justify-center min-h-full p-4 text-center" }

import { Modal } from '@/utils/modal';


export default /*#__PURE__*/_defineComponent({
  __name: 'ModalComponent',
  props: {
    modal: {},
    container_style: {}
  },
  setup(__props: any) {

const props = __props;

// For closing on background click (i.e. mousedown AND mouseup outside of container)
let down_out_container = false;

const mousedown = (e: Event) => {
    const down_target = e.target as Element;
    const container = document.querySelector('.modal-container');
    if (container != null && !container.contains(down_target as Element))
        down_out_container = true;
    else
        down_out_container = false;
}

const mouseup = (e: Event) => {
    if (down_out_container) {
        const up_target = e.target as Element;
        const container = document.querySelector('.modal-container');
        if (container != null && !container.contains(up_target as Element))
            props.modal.close();
    }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    _createVNode(_Transition, {
      name: "modal-transition",
      appear: ""
    }, {
      default: _withCtx(() => [
        (props.modal.is_open.value)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "relative z-10",
              "aria-labelledby": "modal-title",
              role: "dialog",
              "aria-modal": "true",
              onKeydown: _cache[0] || (_cache[0] = _withKeys(($event: any) => (props.modal.close()), ["esc"])),
              tabindex: "0",
              onMousedown: mousedown,
              onMouseup: mouseup
            }, [
              _hoisted_1,
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, [
                  _createElementVNode("div", {
                    class: "modal-container relative bg-white rounded-lg text-left overflow-hidden shadow-xl sm:my-8 sm:max-w-md sm:w-full",
                    style: _normalizeStyle(props.container_style ?? {})
                  }, [
                    _renderSlot(_ctx.$slots, "default")
                  ], 4)
                ])
              ])
            ], 32))
          : _createCommentVNode("", true)
      ]),
      _: 3
    })
  ]))
}
}

})